// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1BT_6","badges":"styles_badges__2Qx4p"};